import { render, staticRenderFns } from "./thuodongGoodsCreateForm.vue?vue&type=template&id=6a361ea8"
import script from "./thuodongGoodsCreateForm.vue?vue&type=script&lang=js"
export * from "./thuodongGoodsCreateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports